import Spinner from "@/Components/Icons/Spinner"

export default function PageSpinner() {
  return (
    <div className="flex justify-center items-center">
      <Spinner width={50} height={50} />
    </div>
  )
}
